import {alpha} from "@mui/material/styles";
import {SurveyQuestionType} from "crqlar-react-common/dist/models/survey/survey.model";
import React from "react";
import {useTranslation} from "react-i18next";
import {
    getSurveyQuestionTypeColor,
    getSurveyQuestionTypeIcon,
    getSurveyQuestionTypeLabelKey
} from "../../surveys/shared/surveyQuestionTypes.util";
import {ElementChip} from "./base/ElementChip";

interface Props {
    type: SurveyQuestionType | undefined;
    asPrint?: boolean;
}

export function SurveyQuestionTypeElement({type, asPrint = false}: Props) {
    const {t} = useTranslation();

    if (!type) return null;

    const text = t(getSurveyQuestionTypeLabelKey(type));

    if (asPrint) {
        return <>{text}</>;
    }

    const color = getSurveyQuestionTypeColor(type);

    return (
        <ElementChip
            text={text}
            startIcon={getSurveyQuestionTypeIcon(type, 15)}
            borderColor={alpha(color, 0.34)}
            backgroundColor={alpha(color, 0.06)}
        />
    );
}

export default SurveyQuestionTypeElement;
